<!-- SPDX-License-Identifier: AGPL-3.0-or-later -->

<h2 matDialogTitle>Third Place Match Config</h2>
<mat-dialog-content>
    <form [formGroup]="form">
        <div class="form-field-container">
            <mat-form-field [appearance]="'outline'">
                <mat-label>Tisch</mat-label>
                <input matInput placeholder="Tisch" formControlName="tableName" />
            </mat-form-field>
            <mat-form-field [appearance]="'outline'">
                <mat-label>Team 1</mat-label>
                <input matInput placeholder="Team 1" formControlName="team1Name" />
            </mat-form-field>
            <mat-form-field appearance="outline">
                <mat-label>Team 1 Drinks picked up</mat-label>
                <mat-select formControlName="team1DrinksCollected">
                    <mat-option [value]="true">Ja</mat-option>
                    <mat-option [value]="false">Nein</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field [appearance]="'outline'">
                <mat-label>Team 2</mat-label>
                <input matInput placeholder="Team 2" formControlName="team2Name" />
            </mat-form-field>
            <mat-form-field appearance="outline">
                <mat-label>Team 2 Drinks picked up</mat-label>
                <mat-select formControlName="team2DrinksCollected">
                    <mat-option [value]="true">Ja</mat-option>
                    <mat-option [value]="false">Nein</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline">
                <mat-label>Gewonnen</mat-label>
                <mat-select formControlName="team1Won">
                    <mat-option [value]="true">Team 1: {{form.controls.team1Name.value}}</mat-option>
                    <mat-option [value]="false">Team 2: {{form.controls.team2Name.value}}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline">
                <mat-label>Match fertig gespielt (Gewinner steht fest)</mat-label>
                <mat-select formControlName="matchFinished">
                    <mat-option [value]="true">Ja</mat-option>
                    <mat-option [value]="false">Nein</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </form>
    <button mat-flat-button color="primary" (click)="save()">Save</button>
</mat-dialog-content>
